import { handleExpiredTokens } from 'api/apiReqSagaCreator/httpRequest';

import BaseRepo from '../../BaseRepo';
import { ApiResponseAsync, translateAxiosErrorToApiError } from '../../models';
import { IScanRepo } from './IScanRepo';

export class ScanRepo extends BaseRepo implements IScanRepo {
  deleteScanInstance = (
    processId: string,
    scanInstanceId: string
  ): ApiResponseAsync<any> =>
    handleExpiredTokens(() =>
      this.client.delete<any>(
        `/processes/${processId}/scan/instances/${scanInstanceId}`
      )
    )
      .then((response) => response.data)
      .catch(translateAxiosErrorToApiError);
}
